import { apiFetch } from '../http';
import type { Filter, FilterInput, Tender } from '../types';

export const filtersApi = {
  list: () => apiFetch<{ data: Filter[] }>('/api/v1/filters'),
  show: (id: number) => apiFetch<{ data: Filter }>(`/api/v1/filters/${id}`),
  create: (input: FilterInput) => apiFetch<{ data: Filter }>('/api/v1/filters', { method: 'POST', body: input }),
  update: (id: number, input: Partial<FilterInput>) =>
    apiFetch<{ data: Filter }>(`/api/v1/filters/${id}`, { method: 'PATCH', body: input }),
  remove: (id: number) => apiFetch<void>(`/api/v1/filters/${id}`, { method: 'DELETE' }),
  preview: (input: FilterInput) =>
    apiFetch<{ data: { count: number; sample: Tender[] } }>('/api/v1/filters/preview', {
      method: 'POST',
      body: input,
    }),
};
